import { memo } from "react";
import { Handle, type NodeProps } from "@xyflow/react";
import { Table } from "lucide-react";
import { cn } from "@/lib/utils";
import type { TableNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export const TableNode = memo(function TableNode({
  data,
  selected,
}: NodeProps) {
  const d = data as TableNodeData;
  const { inputPosition, outputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div
      className={cn(
        "px-4 py-3 rounded-lg border-2 bg-white shadow-sm min-w-[130px]",
        "transition-all duration-150",
        selected
          ? "border-blue-500 shadow-md ring-2 ring-blue-200"
          : "border-blue-300 hover:border-blue-400"
      )}
    >
      <Handle
        type="target"
        position={inputPosition}
        id="input"
        style={{ background: "#3b82f6", width: 8, height: 8 }}
      />
      <Handle
        type="source"
        position={outputPosition}
        id="result"
        style={{ background: "#3b82f6", width: 8, height: 8 }}
      />

      <div className="flex items-center gap-2 mb-1">
        <Table size={14} className="text-blue-600" />
        <span className="text-xs font-semibold text-blue-700">Table</span>
      </div>

      <div className="text-xs font-medium text-slate-700 truncate max-w-[140px]">
        {d.label || "Decision Table"}
      </div>

      <div className="mt-1 flex items-center gap-2 text-[10px] text-muted-foreground">
        <span>{d.rowCount} rows</span>
        <span>{d.columnCount} cols</span>
      </div>
    </div>
  );
});
